module.exports = "/assets/df35760e652556c281ceb1bdefa2ddad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ML.png
// module id = 1618
// module chunks = 0